import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function ToggleElementsUI() {
    this.BUTTON_ACTION = {
        collapse: 'collapse',
        expand: 'expand'
    };

    this.HIDDEN_CLASS = 'extra';
    this.ACTIVE_CLASS = 'active';

    this.defaultAttrs({
        toggleButton: '[data-toggle-elements-button]',
        toggleItems: '[data-toggle-elements-hidden]'
    });

    this._init = function() {
        let toggleButton = this.select('toggleButton');

        let hasActiveLink = this.select('toggleItems').find(
            '.' + this.ACTIVE_CLASS
        ).length;

        if (toggleButton.length > 0 && hasActiveLink > 0) {
            this.select('toggleItems').removeClass(this.HIDDEN_CLASS);
            toggleButton
                .removeClass(this.BUTTON_ACTION.expand)
                .addClass(this.BUTTON_ACTION.collapse);
        } else {
            this.select('toggleItems').addClass(this.HIDDEN_CLASS);
            if (toggleButton.length > 0) {
                toggleButton.addClass(this.BUTTON_ACTION.expand);
            }
        }
    };

    this._toggleOptions = function() {
        let toggleButton = this.select('toggleButton');
        if (toggleButton.hasClass(this.BUTTON_ACTION.collapse)) {
            this._hideOptions();
            toggleButton
                .removeClass(this.BUTTON_ACTION.collapse)
                .addClass(this.BUTTON_ACTION.expand);
        } else {
            this._showOptions();
            toggleButton
                .removeClass(this.BUTTON_ACTION.expand)
                .addClass(this.BUTTON_ACTION.collapse);
        }

        let nodeBottomOffsetY = this.$node.offset().top + this.$node.height();
        if (window.scrollY > nodeBottomOffsetY) {
            window.scrollTo(window.scrollY, this.$node.offset().top);
        }
    };

    this._hideOptions = function() {
        this.select('toggleItems').addClass(this.HIDDEN_CLASS);
    };

    this._showOptions = function() {
        this.select('toggleItems').removeClass(this.HIDDEN_CLASS);
    };

    this.after('initialize', function() {
        this.on('click', {
            toggleButton: this._toggleOptions
        });

        this._init();
    });
}

export default defineComponent.component(ToggleElementsUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/toggle-elements.js